function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
    this.enableCartLimit = window.shopLimit.enable_cart_limit
    this.enableVariantsLimit = window.shopLimit.enable_variants_limits
    this.cartLimit = window.shopLimit.cart_limit
    this.variantLimit = window.shopLimit.variants_limit
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
  if(event.target.name === "plus"){
    const increase = this.validateLimit()
    if(increase === true ) this.input.stepUp() 
  }else{
    this.input.stepDown()
  }
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateLimit() {
     this.enableCartLimit = window.shopLimit.enable_cart_limit
    this.enableVariantsLimit = window.shopLimit.enable_variants_limits
    this.cartLimit = window.shopLimit.cart_limit
    this.variantLimit = window.shopLimit.variants_limit
   const value = parseInt(this.input.value);
    const thisItem = this.closest('.cart-item');
    const thisError = thisItem ?  thisItem.querySelector('.cart-limit-error') : null;
    if(this.enableCartLimit === true &&  window.cart.item_count >= this.cartLimit){
    if(thisError){
      window.checkForcartLimit();
      thisError.textContent = window.cart.item_count === this.cartLimit ?
        'You have reached the maximum cart quantity limit'
        : `Your cart content exceeds the cart quantitiy limit (${this.cartLimit}), please remove some items to proceed to checkout`
      return false
    }
    } else if(this.enableVariantsLimit === true && value >= this.variantLimit){
      if(thisError){
     thisError.textContent = 'You have reached the maximum purchase limit for this size'
      return false
    }
    } 
    return true
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    this.sliderControlWrapper = this.querySelector('.slider-buttons');

    if (!this.sliderControlWrapper) return;
    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');


    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }


    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    // this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);

  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.slider.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  async onVariantChange() {
    this.updateVarintImages();
    this.updateOptions();
    this.updateMasterId();
    // this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      // this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      
      await this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select?.value);
  }
 
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  updateVarintImages(){
    let currentColorOption = document.querySelector('variant-radios input[type="radio"][data-input="color"]:checked');
    let currentSku = currentColorOption ? currentColorOption.getAttribute('data-sku') : '';
    if(!currentSku) return
    let allvarintImages = document.querySelectorAll('.varinat-images_gallery');
      console.log('currentSku',currentSku)
    allvarintImages?.forEach((gallery) => gallery.classList.remove('is_selected_media_gallery'));
    let matchingGalleryItems = document.querySelectorAll('.varinat-images_gallery[data-sku="'+currentSku+'"]')
    // document.querySelector('.varinat-images_gallery[data-sku="'+currentSku+'"]')?.classList.add('is_selected_media_gallery');
    matchingGalleryItems?.forEach(matchingGalleryItem => {
      matchingGalleryItem.classList.add('is_selected_media_gallery');
    })
    
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries?.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  async updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    await this.updateCartLimit()
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  async updateCartLimit(){
    const limit_msg = document.querySelector(".limit_msg");
    limit_msg.innerText = "";
    const quantityToAdd = 1; // You can modify this if you need to use dynamic quantity
    const variantEnable = shopLimit.enable_variants_limits;
    console.log("enable", variantEnable);
    if (variantEnable === true) {
      const isLimitExceeded = await this.checkVariantLimitInCart(
        this.currentVariant.id,
        quantityToAdd
      );
      console.log("isLimitExceeded", isLimitExceeded);
      if (isLimitExceeded) {
        limit_msg.innerText = `You have reached the maximum purchase limit for this size, please choose  another product or size.`;
        return; // Exit the function if the limit is exceeded
      }
    }
  }
  async checkVariantLimitInCart(variantId, quantityToAdd) {
    const cartResponse = await fetch("/cart.js");
    const cartData = await cartResponse.json();
    const variantLimit = shopLimit.variants_limit; // Ensure this is defined correctly
    const existingProductInCart = cartData.items.find(
      (item) => item.variant_id === parseInt(variantId)
    );
    const currentQuantity = existingProductInCart
      ? existingProductInCart.quantity
      : 0;
    if (currentQuantity + quantityToAdd > variantLimit) {
      return true; // Exceeds the variant limit
    }
    return false; // Does not exceed the variant limit
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const destinations = document.querySelectorAll(`#price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        // if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinations) {
          console.log('destinations')
          destinations.forEach(destination => {
            destination.innerHTML = source.innerHTML;
          })
        }
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  updateVariantAvailability(selectElement, radioInputs, inputStock, addButton, text, addButtonText ) {

      let disabledButton = true;
      selectElement.querySelectorAll('option').forEach(option => {
        const variantOption = option.getAttribute('variant-optoion');
        const optionInventory = parseInt(option.getAttribute('data-inventory'));
        const isVariantOptionValid = variantOption !== '-1';
        const threshold = isVariantOptionValid ? variantOption : inputStock;
        const optionCat = option.getAttribute('option-values');
        const optionsCatArray = optionCat ? optionCat.split(',').map(option => option.trim()) : [];
      
        if (optionInventory <= threshold) {
            radioInputs.forEach(input => {
                if (optionsCatArray.includes(input.value)) {
                    input.classList.add('disabled');
                }
            });
        }
    });

      selectElement.querySelectorAll('option').forEach(option => {
        const variantOption = option.getAttribute('variant-optoion');
        const optionInventory = parseInt(option.getAttribute('data-inventory'));
        const isVariantOptionValid = variantOption !== '-1';
        const threshold = isVariantOptionValid ? variantOption : inputStock;
        const optionCat = option.getAttribute('option-values');
        const optionsCatArray = optionCat ? optionCat.split(',').map(option => option.trim()) : [];
      
        if (threshold!==-500 && threshold <= optionInventory) {
            radioInputs.forEach(input => {
                if (optionsCatArray.includes(input.value)) {
                    input.classList.remove('disabled');
                    disabledButton = false;
                }
            });
        }
    });

    if(disabledButton){
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
   if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    const variantInput = document.querySelector('.product-variant-id');
    const selectElement = document.querySelector('#custom_select_hidden_opt');
    const inputValue = variantInput.value;
    const inputStock = parseInt(variantInput.getAttribute('data-stock'));
    const radioInputs = document.querySelectorAll('fieldset.js.product-form__input input[type="radio"]');
    if( inputValue == "-500"){
        selectElement.querySelectorAll('option').forEach(option => {
        const variantOption = option.getAttribute('variant-optoion');
        const optionValue = option.value;
        const optionInventory = parseInt(option.getAttribute('data-inventory'));
          
        if (variantOption !== '-1' && optionValue === inputValue) {
          const isDisabled = optionInventory <= variantOption;
          if (isDisabled) {
            addButton.setAttribute('variantBufferVarified', true);
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
          }else{
            addButton.setAttribute('variantBufferVarified', false);
          } 
           this.updateVariantAvailability(selectElement, radioInputs, inputStock, addButton, text, addButtonText );
        }else{
          addButton.setAttribute('variantBufferVarified', false);
        }
    }); 
    
  }else{
   selectElement.querySelectorAll('option').forEach(option => {
        const variantOption = option.getAttribute('variant-optoion');
        const optionValue = option.value;
        const optionInventory = parseInt(option.getAttribute('data-inventory'));
        if (optionValue === inputValue) {
            if (String(variantOption) !== '-1') {
                const isDisabled = optionInventory <= variantOption;
                if (isDisabled) {
                    addButton.setAttribute('variantBufferVarified', true); 
                    addButton.setAttribute('disabled', 'disabled');
                    if (text) addButtonText.textContent = text;
                } else{
                  addButton.setAttribute('variantBufferVarified', false);
                } 
               this.updateVariantAvailability(selectElement, radioInputs, inputStock, addButton, text, addButtonText );
          }else{
              if (optionInventory <= inputStock) {
                  addButton.setAttribute('variantBufferVarified', true);
                  addButton.setAttribute('disabled', 'disabled');
                  if (text) addButtonText.textContent = text;
                  this.updateVariantAvailability(selectElement, radioInputs, inputStock, addButton, text, addButtonText );
              }else{
                  addButton.setAttribute('variantBufferVarified', false);
          } 
               
        }
     }
    }); 
  }





    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);



//  size guide gender toggle
var sizeDropdown = document.querySelectorAll(".guide_drop_ul");
if (sizeDropdown) {
  sizeDropdown.forEach((sizeDrop) => {
    var sizeDeopdownItems = sizeDrop.querySelectorAll("li");
    sizeDeopdownItems.forEach((sizeDropItem) => {
      sizeDropItem.addEventListener("click", () => {
        if (sizeDropItem.classList.contains("gender_li")) {
          var datatypeli = sizeDropItem.getAttribute("data-type");
          var sizeul = document.querySelectorAll(".dropdown_other_shoes");
          sizeul.forEach((sizeulData) => {
            var datatypeUl = sizeulData.getAttribute("data-type");
            if (datatypeUl == datatypeli) {
              sizeulData.classList.remove("hidden");
              var selected = sizeulData.querySelector('.drop_active').innerHTML;
              sizeulData.closest('details').querySelector(".selected_unisex").innerHTML = selected;

              var shoActiveli = sizeulData.querySelector('.drop_active').getAttribute("data-type");
              var sizetable = document.querySelectorAll(".table-wrapper");
              sizetable.forEach((table) => {
                if (table.classList.contains(shoActiveli) && table.classList.contains(datatypeli)) {
                  table.classList.remove("hidden");
                } else {
                  table.classList.add("hidden");
                }
              });
            } else {
              sizeulData.classList.add("hidden");
            }
          });
        }

        var sizeDropItemss = sizeDropItem.closest('details').querySelector(".selected_unisex").innerHTML = sizeDropItem.innerHTML;
        sizeDropItem.closest("details").removeAttribute("open");
        sizeDropItem.classList.add("drop_active");
        sizeDeopdownItems.forEach((dropItemSibling) => {
          if (dropItemSibling != sizeDropItem) {
            dropItemSibling.classList.remove("drop_active");
          }
        });

      });
    });
  });
  // Handle clicks on items in the second dropdown
  var sizeDropdownOther = document.querySelectorAll(".dropdown_other_shoes li");
  if (sizeDropdownOther) {
    sizeDropdownOther.forEach((sizeDropItemOther) => {
      sizeDropItemOther.addEventListener("click", () => {
        var dataTypeLi = sizeDropItemOther.getAttribute("data-type");
        var selectedTypeLi = document.querySelector(".guide_drop_ul .drop_active").getAttribute("data-type");
        var selectedTypeUl = sizeDropItemOther.closest(".dropdown_other_shoes").getAttribute("data-type");

        var sizetables = document.querySelectorAll(".table-wrapper");
        sizetables.forEach((table) => {
          if (table.classList.contains(dataTypeLi) && table.classList.contains(selectedTypeLi) && table.classList.contains(selectedTypeUl)) {
            table.classList.remove("hidden");
          } else {
            table.classList.add("hidden");
          }
        });
      });
    });
  }
}
//size guide at a time one dropdown open
var DropDeatils = document.querySelectorAll(".drop_details");
if (DropDeatils) {
  DropDeatils.forEach((detail) => {
    detail.addEventListener("click", () => {
      // Close all other details
      DropDeatils.forEach((otherDetail) => {
        if (otherDetail != detail) {
          otherDetail.removeAttribute("open");
        }
      });
    });
  });
}


// mega menu on hover open
let items = document.querySelector(".header__inline-menu").querySelectorAll(".mega-menu");
// console.log(items)
items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });

});

document.querySelector(".list-menu--inline").classList.add('done');


let dropdownItems = document.querySelector('.header__inline-menu').querySelectorAll('.dropdown-item');
dropdownItems.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.classList.add('show');
    //item.querySelector("ul").addEventListener("mouseleave", () => {
      //item.removeAttribute("open");
      //item.classList.remove('show');
    //});
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      item.classList.remove('show');
    });
  });

});

var crossIcon = document.querySelector('.cross_svg');
var drawer = document.querySelector('.menu-drawer-container');
var innerdrawer = document.querySelector('.header__icon--menu');
if(crossIcon){
  crossIcon.addEventListener('click', function () {
    drawer.removeAttribute("open");
    innerdrawer.setAttribute("aria-expanded", "false");
    document.body.classList.remove('overflow-hidden-tablet');
  });
}




const backHeight = document.querySelectorAll('.child_back');
Array.from(backHeight).forEach(function (Bheight) {
  Bheight.addEventListener('click', function () {
    function greet() {
      document.querySelector('.selected_height').style.height = 'auto';
    }
    setTimeout(greet, 100);
  });
});

const summaryElements1 = document.querySelectorAll('li.child_menu_li > details > summary');
summaryElements1.forEach(function (summary) {
  summary.addEventListener('click', function () {
    function greet() {
      const submenu = summary.parentElement.querySelector('.grand_child_m');
      const getHeight = submenu.offsetHeight + 'px';
      document.querySelector('.selected_height').style.height = getHeight;
    }
    setTimeout(greet, 400);
  });
});

const grand = document.querySelectorAll('.grand_child_back');
Array.from(grand).forEach(function (gh) {
  gh.addEventListener('click', function () {
    function greet() {
      const getAttribute = gh.closest('.main_d_li').getAttribute('data-height');
      document.querySelector('.selected_height').style.height = getAttribute;
    }
    setTimeout(greet, 200);
  });
});





// account_popup
const accountIcon = document.querySelector('.forget_pas');
const accountOverlay = document.querySelector('.account_overlay');
const accountData = document.querySelector('.account_popup');
const accountClose = document.querySelector('.modal_close_icon');
const accountClosebtn = document.querySelector('.closed_btn');

if (accountIcon) {
  accountIcon.addEventListener('click', function (event) {
    event.preventDefault();
    document.querySelector('body').style.overflow = 'hidden';
    accountData.style.display = 'flex';
  });
}

if (accountClose) {
  accountClose.addEventListener('click', function () {
    accountData.style.display = 'none';
    document.querySelector('body').style.overflow = 'unset';
  });
}
if (accountClosebtn) {
  accountClosebtn.addEventListener('click', function () {
    accountData.style.display = 'none';
    document.querySelector('body').style.overflow = 'unset';
  });
}

if (accountOverlay) {
  accountOverlay.addEventListener('click', function (event) {
    if (event.target === accountOverlay) {
      accountData.style.display = 'none';
      document.querySelector('body').style.overflow = 'unset';
    }
  });
}

// account page password visible
const password_eye = document.querySelectorAll('.paswrd_eye');
if (password_eye) {
  password_eye.forEach(function (eye) {
    eye.addEventListener('click', function () {
      const alleye = this.closest('.password_visible').querySelectorAll('.paswrd_eye');
      alleye.forEach(function (sl) {
        sl.classList.remove('hide_eye');
      });
      eye.classList.add('hide_eye');
      const getinput = this.closest('.password_visible').nextElementSibling.querySelector('input');
      const typeget = getinput.getAttribute('type');
      if (typeget == 'password') {
        this.closest('.password_visible').nextElementSibling.querySelector('input').setAttribute('type', 'text');
      } else {
        this.closest('.password_visible').nextElementSibling.querySelector('input').setAttribute('type', 'password');
      }
    });
  });
}


document.addEventListener('click', function (event) {
  const isClickInsideForm = event.target.closest('.account_form');
  if (!isClickInsideForm) {
    // Clicked outside the form, hide error messages
    const genderErrorMessage = document.querySelector('.gender_error_message');
    const birthdayErrorMessage = document.querySelector('.birthday_error_message');

    if (genderErrorMessage) {
      genderErrorMessage.style.display = 'none';
    }
    if (birthdayErrorMessage) {
      birthdayErrorMessage.style.display = 'none';
    }
  }
});

// // account page validation
const forms = document.querySelectorAll('.account_form');

forms.forEach(form => {
  const inputs = form.querySelectorAll('.main_input_field input');


  inputs.forEach(input => {
    input.addEventListener('input', () => {
      validateInput(input);
    });

    input.addEventListener('blur', () => {
      validateInput(input);
    });

  });

  form.addEventListener('submit', event => {
    // event.preventDefault();
    validateForm(form);


    if (form.checkValidity()) {

      console.log('Form submitted!');
    }
  });
  document.addEventListener('click', function (event) {
    if (event.target && event.target.classList.contains('sam_btn')) {
      const form = event.target.closest('.account_form');
      if (form) {
        const inputs = form.querySelectorAll('.main_input_field input');
        inputs.forEach(input => {
          validateInput(input);
        });
      }
    }
  });

});


function validateInput(input) {
  const addvalid = input.closest('.main_input_field');
  const errorMessage = addvalid.querySelector('.account_error_input');
  const originalErrorMessage = errorMessage.getAttribute('data-original-message');
  const svgINvalid = addvalid.querySelector('.invalid_svg');
  const svgvalid = addvalid.querySelector('.valid_svg');
  // console.log('originalErrorMessage', originalErrorMessage)
  if (!input.checkValidity()) {
    if (input.value.trim() !== "") {
      const customErrorMessage = errorMessage.getAttribute('data-error-message');
      errorMessage.textContent = customErrorMessage;
    } else {
      errorMessage.textContent = originalErrorMessage;
    }
    errorMessage.style.display = 'block';
    addvalid.classList.add('input__error');
    
    if (typeof(svgINvalid) != 'undefined' && svgINvalid != null) {
      svgINvalid.style.display = 'block';
    }
    if (typeof(svgvalid) != 'undefined' && svgvalid != null) {
      svgvalid.style.display = 'none';
    }
    input.classList.remove('green_border')
  } else {
    errorMessage.textContent = originalErrorMessage;
    errorMessage.style.display = 'none';    
    input.classList.add('green_border')
    addvalid.classList.remove('input__error');
    
    if (typeof(svgINvalid) != 'undefined' && svgINvalid != null) {
      svgINvalid.style.display = 'none';
    }
    if (typeof(svgvalid) != 'undefined' && svgvalid != null) {
      svgvalid.style.display = 'block';
    }
    if (input.value.trim() === "") {
      removeError(input);
    }
  }

  validateForm(input.form);
}

function removeError(input) {
  const addvalid = input.closest('.main_input_field');
  const errorMessage = addvalid.querySelector('.account_error_input');

  errorMessage.style.display = 'none';
  addvalid.classList.remove('input__error');
}

function validateForm(form) {
  const inputs = form.querySelectorAll('.main_input_field input');
  const submitbtn = form.querySelector('.account_btn');
  const sam_btn = form.querySelector('.sam_btn');
  const checkbox = form.querySelector('.optional_reg');
  const genderErrorMessage = form.querySelector('.gender_error_message');
  const birthdayErrorMessage = form.querySelector('.birthday_error_message');

  let allInputsValid = true;
  inputs.forEach(input => {  
    if (input.attributes["required"] == "true"){
      if (!input.checkValidity() || input.value.trim() === "") {
        allInputsValid = false;
      }
    }
  });

  const selectedGender = document.getElementById('RegisterForm-Gender');
  if (selectedGender) {
    // Function to handle change in gender selection
    function handleGenderChange() {
      if (selectedGender.value !== "") {
        genderErrorMessage.style.display = 'none';
      } else {
        genderErrorMessage.style.display = 'block';
      }
    }
    // Add onchange event listener to gender select element
    selectedGender.addEventListener('change', handleGenderChange);
    // Initial validation on page load
    handleGenderChange();
  }


  const birthdayInput = document.getElementById('birthday');
  if (birthdayInput) {
    if (birthdayInput.value === '') {
      allInputsValid = false;
      if (birthdayErrorMessage) {
        birthdayErrorMessage.style.display = 'block';
      }
    } else {
      if (birthdayErrorMessage) {
        birthdayErrorMessage.style.display = 'none';
      }
    }
  }

  if (allInputsValid) {
    submitbtn.classList.remove('hidden');
    sam_btn.classList.add('hidden');
    if (checkbox) {
      checkbox.classList.remove('CheckboxDisable');
    }

  } else {
    submitbtn.classList.add('hidden');
    sam_btn.classList.remove('hidden');
    if (checkbox) {
      checkbox.classList.add('CheckboxDisable');
    }

  }
}


(function () {
  var REDIRECT_PATH = '/account';

  var selector = '#create_customer, form[action$="/account"][method="post"]',
    $form = document.querySelectorAll(selector)[0];

  if ($form) {
    $redirect = document.createElement('input');
    $redirect.setAttribute('name', 'return_to');
    $redirect.setAttribute('type', 'hidden');
    $redirect.value = REDIRECT_PATH;
    $form.appendChild($redirect);
  }
})();

// lineashoes pdp
// pdp size selection
var pdpATCBtn = document.querySelector('.product-form__submit');
var shopifyPaymentButtons = document.querySelector('.shopify-payment-button');
var productAtcForm = document.querySelector('[data-type="add-to-cart-form"]');
if(shopifyPaymentButtons){
  var buyNowBtn = shopifyPaymentButtons.querySelector('.shopify-payment-button__button');  
}

var sizeLabelContainer = document.querySelector('.title_with_size_guide');
var sizeContainer = document.querySelector('.product-form__input-size');
var colorContainer = document.querySelector('.product-form__input-color');

if(colorContainer){
  var colorLabels = colorContainer.querySelectorAll('label.swatch-color-label');
  if(colorLabels){
    colorLabels.forEach(colorLabel => {
      colorLabel.addEventListener('click', () => {
        var colorLabelValue = colorLabel.dataset.value;
        document.querySelector('[data-selected-value]').textContent = colorLabelValue;
      })
    })
  }
}

if(pdpATCBtn){
  pdpATCBtn.addEventListener('click', (e) => {
    sizeNotice(e)
  })
}





function sizeNotice(e){
if(pdpATCBtn.classList.contains('disabled')){
    e.preventDefault();
    sizeContainer.classList.add('error');
    sizeLabelContainer.querySelector('.size-notice').classList.remove('hidden');
    void sizeContainer.offsetWidth;
    sizeContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

if(sizeContainer){
  var sizeLabels = sizeContainer.querySelectorAll('label');
  console.log('sizeLabels', sizeLabels);
  if(sizeLabels){
    sizeLabels.forEach(sizeLabel => {
      sizeLabel.addEventListener('click', () => {
        pdpATCBtn.classList.remove('disabled');
        sizeContainer.classList.remove('error');
        sizeLabelContainer.querySelector('.size-notice').classList.add('hidden');
      })
    })
  }
}

// store locator availability
document.addEventListener('DOMContentLoaded', () => {
  const checkStoreAvailability = document.querySelector('.check-store-availablity a');
  const productVariantsContainer = document.querySelector('variant-radios');
  const productATCForm = document.querySelector('.main-product-form');
  const pdpATCBtn = document.querySelector('.product-form__submit');

  if (!productATCForm || !checkStoreAvailability) return;

  const productHandle = productATCForm.getAttribute('data-product-handle');
 
  function getLocations() {
    try {
      const getVariantIdInput = productATCForm.querySelector('input[name="id"]');
      if (!getVariantIdInput) {
        console.error('Variant ID input not found');
        return;
      }

      const getVariantId = getVariantIdInput.value;
      const rootUrl = `/products/${productHandle}?variant=${getVariantId}&view=store-locator`;

      fetch(rootUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.text();
        })
        .then(text => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const pickupLocations = doc.querySelector('.pickup-locations');
          
          if (!pickupLocations) {
            updateStoreAvailabilityUI(false);
            return;
          }

          const targetedVariant = pickupLocations.querySelector(`[data-variant-id="${getVariantId}"]`);
          if (!targetedVariant) {
            updateStoreAvailabilityUI(false);
            return;
          }

          const targetVariantPickups = parseInt(targetedVariant.dataset.variantPickup, 10);
          const targetedVariantLocations = Array.from(targetedVariant.querySelectorAll('li'));

          const availableItems = targetedVariantLocations.filter(item => 
            item.getAttribute('data-variant-availability') === 'true'
          );

          updateStoreAvailabilityUI(availableItems.length > 0);
          updateAmaiLocations(availableItems);
        })
        .catch(error => {
          console.error('Error fetching store locations:', error);
          updateStoreAvailabilityUI(false);
        });
    } catch (error) {
      console.error('Unexpected error in getLocations:', error);
      updateStoreAvailabilityUI(false);
    }
  }

  function updateStoreAvailabilityUI(hasAvailableLocations) {
    if (!checkStoreAvailability) return;

    if (hasAvailableLocations) {
      checkStoreAvailability.classList.remove('no-locations', 'hidden');
    } else {
      checkStoreAvailability.classList.add('no-locations', 'hidden');
    }
  }

  function updateAmaiLocations(availableItems) {
    const amaiPopup = document.querySelector('#wtb-popup-wrapper');
    if (!amaiPopup) return;

    const amaiLocationsList = amaiPopup.querySelector('#stockist-locations');
    if (!amaiLocationsList) return;

    const amaiLocations = amaiLocationsList.querySelectorAll('.location-item');
    
    amaiLocations.forEach(amaiLocation => {
      const availableLocation = availableItems.find(item => 
        item.getAttribute('data-metafield-id') === amaiLocation.getAttribute('data-id')
      );

      if (availableLocation) {
        amaiLocation.classList.add('available-location');
        amaiLocation.classList.remove('hidden', 'selected-item');
      } else {
        amaiLocation.classList.remove('available-location', 'selected-item');
        amaiLocation.classList.add('hidden');
      }
    });
  }

  if (productVariantsContainer) {
    const productVariants = productVariantsContainer.querySelectorAll('label');
    productVariants.forEach(productVariant => {
      productVariant.addEventListener('click', getLocations);
    });
  }

  setTimeout(getLocations, 1000);

  if (checkStoreAvailability) {
    checkStoreAvailability.addEventListener('click', (e) => {
      e.preventDefault();
      
      if (pdpATCBtn) {
        if (pdpATCBtn.classList.contains('disabled')) {
          pdpATCBtn.click();
        } else {
          const wtbBtn = document.querySelector('#wtb-btn');
          if (wtbBtn) {
            const amaiPopup = document.querySelector('#wtb-popup-wrapper');
            const amaiLocationsList = amaiPopup?.querySelector('#stockist-locations');
            
            if (amaiLocationsList) {
              const amaiLocations = amaiLocationsList.querySelectorAll('.location-item');
              amaiLocations.forEach(amaiLocation => {
                if (amaiLocation.classList.contains('available-location')) {
                  amaiLocation.classList.remove('hidden');
                }
              });
            }
            
            wtbBtn.click();
          }
        }
      }
    });
  }
});
// ---------------------------------------

var urlParams = new URLSearchParams(window.location.search);
var formType = urlParams.get('form_type');
var hash = window.location.hash;

// Check for the specific form_type and hash
if (formType === 'customer' && hash === '#ContactFooter') {
  var successMessage = document.getElementById('ContactFooter-success');
  if (successMessage) {
    successMessage.style.display = 'block'; // Show the success message
    successMessage.focus(); // Set focus if needed
  }
}

const sliderThreshold = 100;
document.querySelectorAll("ul.grid.slider").forEach(slider => {
  let isDragging = false;
  let startX, startScroll;
  const slides = slider.querySelectorAll('li.grid__item.slider__slide');

  slider.addEventListener("mousedown", function(event) {
    startDrag.call(this, event);
  });

  slider.addEventListener("mousemove", function(event) {
    drag.call(this, event);
  });

  slider.addEventListener("mouseup", function() {
    stopDrag.call(this);
  });

  slider.addEventListener("mouseleave", function() {
    stopDrag.call(this);
  });

  function startDrag(event) {
    isDragging = true;
    startX = event.clientX;
    startScroll = this.scrollLeft;
    event.preventDefault();   
  }

  function drag(event) {
    if (!isDragging) return;
    const x = event.clientX;
    const distance = x - startX;

    if (Math.abs(distance) >= sliderThreshold) {
      if (distance > 0) {
        this.scrollLeft = startScroll - distance;         
      } else {

        this.scrollLeft = startScroll - distance;
      }
    }

    slides.forEach(slide => {
      slide.style.pointerEvents = 'none';
    });
  }

  function stopDrag() {
    isDragging = false;
    slides.forEach(slide => {
      slide.style.pointerEvents = 'all';
    });
  }
});



const slideshowThreshold = 100;

document.querySelectorAll(".slideshow").forEach(slideshow => {
  let isDragging = false;
  let startX, startScroll;
  const slides = slideshow.querySelectorAll('.slideshow__slide');

  slideshow.addEventListener("mousedown", function(event) {
    startDrag.call(this, event);
  });

  slideshow.addEventListener("mousemove", function(event) {
    drag.call(this, event);
  });

  slideshow.addEventListener("mouseup", function() {
    stopDrag.call(this);
  });

  slideshow.addEventListener("mouseleave", function() {
    stopDrag.call(this);
  });

  function startDrag(event) {
    isDragging = true;
    startX = event.clientX;
    startScroll = this.scrollLeft;
    event.preventDefault();
  }

  function drag(event) {
    if (!isDragging) return;
    const x = event.clientX;
    const distance = x - startX;

    if (Math.abs(distance) >= slideshowThreshold) {
      if (distance > 0) {
        // Drag to right
        this.scrollLeft = startScroll - distance - 900; // Adjust as needed
      } else {
        // Drag to left
        this.scrollLeft = startScroll - distance + 900; // Adjust as needed
      }
    }

    slides.forEach(slide => {
      slide.style.pointerEvents = 'none';
    });
  }

  function stopDrag() {
    isDragging = false;
    slides.forEach(slide => {
      slide.style.pointerEvents = 'all';
    });
  }
});





document.addEventListener("DOMContentLoaded", function () {

  const accordions = document.querySelectorAll('.product__accordion.meta-accordion');

  accordions.forEach(accordion => {
    const header = accordion.querySelector('.accordion__header');
    const content = accordion.querySelector('.accordion__content');

    content.style.maxHeight = '0';
    content.style.opacity = '0';

    header.addEventListener('click', function () {
      const isOpen = content.classList.contains('open');

      accordions.forEach(otherAccordion => {
        if (otherAccordion !== accordion) {
          const otherContent = otherAccordion.querySelector('.accordion__content');
          const otherHeader = otherAccordion.querySelector('.accordion__header');
          otherContent.classList.remove('open');
          otherHeader.classList.remove('open');
          otherContent.style.maxHeight = '0';
          otherContent.style.opacity = '0';
        }
      });

      if (isOpen) {
        content.classList.remove('open');
        content.style.maxHeight = '0';
        content.style.opacity = '0';
      } else {
        content.classList.add('open');
        content.style.maxHeight = (content.scrollHeight + 20) + 'px';
        content.style.opacity = '1';
      }

      header.classList.toggle('open');
    });
  });
});

